module.exports = "https://cdn2-fs.clearscore.com/flux/images/f11badb17cf2f89fec340c53d27b1a25.jpg";